import { createAnalyticsGroup } from 'js/lib/analytics'

const ediLogo = document.querySelectorAll('.js-c-logo--edi')

if (ediLogo.length > 0) {
  const track = createAnalyticsGroup('partner-logo--edi')
  const currentPage = window.location.href
  
  ediLogo.forEach(link => {
    
    if (link) {
      link.addEventListener('click', () => {
        track('click', `EDI logo from ${currentPage}`)
      })
    }
  })
}
